import JSZip from "jszip";
import { saveAs } from "file-saver";
import { DEFAULT_ZIP_DOWNLOAD_NAME } from "src/helpers";

export const downloadFile = (file: File) => {
  saveAs(file, file.name);
};

export const downloadFilesAsZip = async (files: File[], zipName = DEFAULT_ZIP_DOWNLOAD_NAME) => {
  const zip = new JSZip();

  files.forEach((file) => zip.file(file.name, file));

  const content = await zip.generateAsync({ type: "blob" });

  saveAs(content, zipName);
};
